import { Box } from '@quintoandar-tokko/jopijs';
import styles from './components.module.scss';

export default function ProgressBar({
  percentage = 100,
  color = '#ff6769',
  className = '',
  ...props
}) {
  const classNames = `${styles.progressBarWrapper} ${className}`;

  return (
    <Box className={classNames} {...props}>
      <Box
        className={styles.progressBar}
        __css={{ backgroundColor: color, width: `${percentage}%` }}
      />
    </Box>
  );
}
